module.exports = {
  PluginManifest: require('./lib/PluginManifest'),
  PluginStore: require('./lib/PluginStore'),
}



//////////////////
// WEBPACK FOOTER
// ./~/graylog-web-plugin/plugin.js
// module id = 281
// module chunks = 0